// src/pages/tasks/TaskCreateModal.jsx
import { useState } from "react";
import * as api from "../../apiService";

const PRIORITIES  = ["LOW", "MEDIUM", "HIGH", "URGENT"];
const DEPARTMENTS = ["ADMIN", "ACCOUNTS", "SALES", "QC", "PRODUCTION", "STORES", "MAINTENANCE"];

const EMPTY = {
  title: "", description: "", assignedTo: "",
  dueDate: "", priority: "MEDIUM", department: "",
};

export function TaskCreateModal({ users, onSave, onCancel }) {
  const [form,   setForm]   = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const [error,  setError]  = useState(null);

  function set(f, v) { setForm(p => ({ ...p, [f]: v })); }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.title.trim())    { setError("Title is required.");           return; }
    if (!form.assignedTo)      { setError("Assign to a user.");            return; }
    setSaving(true); setError(null);
    try {
      await onSave({
        title:      form.title.trim(),
        description:form.description.trim() || null,
        assignedTo: form.assignedTo,
        dueDate:    form.dueDate || null,
        priority:   form.priority,
        department: form.department || null,
      });
    } catch (err) {
      setError(err.message);
      setSaving(false);
    }
  }

  const sortedUsers = [...users].sort((a, b) => (a.name || a.email).localeCompare(b.name || b.email));

  return (
    <div className="modal wide">
      <div className="modal-header">
        <h3 className="modal-title">New Task</h3>
        <button className="btn" onClick={onCancel}>✕</button>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <span className="form-label">Title *</span>
          <input className="form-input" value={form.title}
            onChange={e => set("title", e.target.value)}
            placeholder="Task title" style={{ flex: 1 }} />
        </div>

        <div className="form-row">
          <span className="form-label">Description</span>
          <textarea className="form-input" rows={3}
            value={form.description}
            onChange={e => set("description", e.target.value)}
            placeholder="Optional details…"
            style={{ flex: 1, resize: "vertical" }} />
        </div>

        <div className="form-row">
          <span className="form-label">Assign To *</span>
          <select className="form-select" value={form.assignedTo}
            onChange={e => set("assignedTo", e.target.value)} style={{ flex: 1 }}>
            <option value="">— select user —</option>
            {sortedUsers.map(u => (
              <option key={u.email} value={u.email}>{u.name || u.email} ({u.email})</option>
            ))}
          </select>
        </div>

        <div className="form-row">
          <span className="form-label">Due Date</span>
          <input type="date" className="form-input" value={form.dueDate}
            onChange={e => set("dueDate", e.target.value)} style={{ width: 160 }} />
        </div>

        <div className="form-row">
          <span className="form-label">Priority</span>
          <select className="form-select" value={form.priority}
            onChange={e => set("priority", e.target.value)} style={{ width: 140 }}>
            {PRIORITIES.map(p => <option key={p} value={p}>{p}</option>)}
          </select>
        </div>

        <div className="form-row">
          <span className="form-label">Department</span>
          <select className="form-select" value={form.department}
            onChange={e => set("department", e.target.value)} style={{ width: 180 }}>
            <option value="">— none —</option>
            {DEPARTMENTS.map(d => <option key={d} value={d}>{d}</option>)}
          </select>
        </div>

        {error && <div className="alert-warn" style={{ marginTop: 8 }}>{error}</div>}

        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 16 }}>
          <button type="button" className="btn" onClick={onCancel} disabled={saving}>Cancel</button>
          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? "Saving…" : "Create Task"}
          </button>
        </div>
      </form>
    </div>
  );
}
